import { Component, ViewEncapsulation } from '@angular/core';
import {
  IconsModule,
  IconWrapperComponent,
} from '@progress/kendo-angular-icons';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import {
  SVGIcon,
  checkCircleIcon,
  warningCircleIcon,
  warningTriangleIcon,
  xIcon,
  infoSolidIcon,
  minusCircleIcon,
} from '@progress/kendo-svg-icons';
import { type ToastButtonAction, type ToastVariant } from './toast-types';

const VARIANT_ICONS: Record<ToastVariant, SVGIcon> = {
  success: checkCircleIcon,
  error: warningCircleIcon,
  warning: warningTriangleIcon,
  info: infoSolidIcon,
  neutral: minusCircleIcon,
};

@Component({
  selector: 'app-toast-content',
  standalone: true,
  imports: [IconsModule, IconWrapperComponent, ButtonsModule],
  templateUrl: './toast-content.component.html',
  styleUrl: './toast-content.component.scss',
  // ViewEncapsulation.None is required because this component is dynamically
  // injected by Kendo's NotificationService — its styles must reach the Kendo
  // host container and the variant CSS classes applied via cssClass.
  encapsulation: ViewEncapsulation.None,
})
export class ToastContentComponent {
  title = '';
  description = '';
  variant: ToastVariant = 'neutral';
  buttonAction: ToastButtonAction | undefined;
  onClose: (() => void) | undefined;

  get iconSvg(): SVGIcon {
    return VARIANT_ICONS[this.variant];
  }

  readonly xIcon = xIcon;

  handleClose(): void {
    this.onClose?.();
  }
}
